import { Space } from "antd";
import styled from "styled-components";

export const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.5rem;
  background: linear-gradient(135deg, #0a1628 0%, #1a2942 50%, #0d1b2a 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  height: var(--header-height, 60px);
  position: relative;
  z-index: 1001;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.15),
    0 4px 16px rgba(0, 0, 0, 0.1);

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 153, 0, 0.3), transparent);
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
`;

export const Project = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  font-weight: 400;
  padding-left: 1rem;
  display: inline-flex;
  align-items: center;
  position: relative;
  letter-spacing: 0.02em;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 0;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }

  .ant-image {
    display: flex;
    align-items: center;
  }

  span {
    color: #ff9900;
    font-size: 1.25rem;
    font-weight: 600;
    margin-left: 0.5rem;
    letter-spacing: -0.01em;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }
`;

export const SpaceRight = styled(Space)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.25rem;

  .ant-space-item {
    height: 100%;
  }
`;

export const NavItem = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background: ${props => (props.$isActive ? "rgba(255, 153, 0, 0.1)" : "transparent")};

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: translateY(-1px);

    .nav-icon {
      color: #ff9900;
      transform: scale(1.1);
    }

    .nav-text {
      color: #ffffff;
    }
  }

  &:active {
    transform: translateY(0);
    background: rgba(255, 255, 255, 0.12);
  }

  .nav-icon {
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.85);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-text {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.75);
    font-weight: 500;
    transition: color 0.2s ease;
    white-space: nowrap;
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.12);
  margin: 0 0.5rem;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 153, 0, 0.3);
    transform: translateY(-1px);

    .user-avatar {
      border-color: #ff9900;
      box-shadow: 0 0 0 2px rgba(255, 153, 0, 0.2);
    }

    .user-name {
      color: #ffffff;
    }
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff9900 0%, #ffb84d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0a1628;
    font-size: 1rem;
    font-weight: 600;
    border: 2px solid transparent;
    transition: all 0.2s ease;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }

  .user-name {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    transition: color 0.2s ease;
    line-height: 1.2;
  }

  .user-role {
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
    line-height: 1.2;
  }
`;

export const IconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: rgba(255, 255, 255, 0.75);
  font-size: 1.125rem;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ff9900;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
`;
